module.exports = __webpack_public_path__ + "static/img/scoia.231e29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scoia.png
// module id = Un7B
// module chunks = 0